<template>
  <div class="details-container">
    <!-- 导航栏 -->
    <div class="nav-bar">
      <div class="back-btn" @click="goBack">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="nav-title">音频详情</div>
      <div class="nav-actions">
        <i class=""></i>
      </div>
    </div>

    <div class="details-content">
      <div class="detail-item">
        <div class="detail-item-title">{{ name }}</div>
        <div class="detail-item-content">{{ extra }}</div>
      </div>
    </div>
    <audio
      ref="audioPlayer"
      :src="audioUrl"
      @play="onPlay"
      @pause="onPause"
      @ended="onAudioEnded"
    ></audio>

    <div class="bf">
      <div class="bfq">
        <div v-if="!isPlaying" class="bf-btn-play" @click="togglePlay">
          <i class="el-icon-video-play"></i>
        </div>
        <div v-else class="bf-btn-pause" @click="togglePlay">
          <i class="el-icon-video-pause"></i>
        </div>
        <div class="bf-progress">
          <div class="bf-time">{{ createTime }}</div>
          <div class="bf-duration">{{ userId }}</div>
        </div>
      </div>
    </div>

    <div class="bf-btn">
      <!-- <div class="bf-btn-text">文件</div> -->
      <div class="bf-btn-download" @click="downloadAudio">
        下载
        <i class="el-icon-download"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Details",
  data() {
    return {
      extra: "",
      name: "",
      audioUrl: "",
      id: "",
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      audioPlayer: null,
      userId: "",
      createTime: "",
      
    };
  },
  computed: {
    progressPercent() {
      if (this.duration === 0) return 0;
      return (this.currentTime / this.duration) * 100;
    },
  },
  methods: {
    goBack() {
      this.pauseAudio();
      this.$router.back();
    },
    togglePlay() {
      const audio = this.$refs.audioPlayer;
      if (!audio || !this.audioUrl) {
        this.$message.warning("暂无音频资源");
        return;
      }

      if (audio.paused) {
        audio
          .play()
          .then(() => {
            console.log("音频播放成功");
          })
          .catch((error) => {
            console.error("音频播放失败:", error);
            if (error.name === "NotSupportedError") {
              this.$message.error("不支持的音频格式");
            } else if (error.name === "AbortError") {
              this.$message.warning("播放被中断");
            } else {
              this.$message.error("音频播放失败: " + error.message);
            }
          });
      } else {
        audio.pause();
      }
    },
    pauseAudio() {
      const audio = this.$refs.audioPlayer;
      if (audio && !audio.paused) {
        audio.pause();
      }
    },
    restartAudio() {
      const audio = this.$refs.audioPlayer;
      if (!audio || !this.audioUrl) {
        this.$message.warning("暂无音频资源");
        return;
      }
      audio.currentTime = 0;
      audio
        .play()
        .then(() => {
          console.log("音频重新播放成功");
        })
        .catch((error) => {
          console.error("音频重新播放失败:", error);
          this.$message.error("音频重新播放失败: " + error.message);
        });
    },
    seekAudio(event) {
      const audio = this.$refs.audioPlayer;
      if (!audio || !this.audioUrl) return;

      const progressBar = event.currentTarget;
      const rect = progressBar.getBoundingClientRect();
      const clickX = event.clientX - rect.left;
      const percent = clickX / rect.width;

      audio.currentTime = percent * this.duration;
    },
    onTimeUpdate() {
      const audio = this.$refs.audioPlayer;
      if (audio) {
        this.currentTime = audio.currentTime;
      }
    },
    onLoadedMetadata() {
      const audio = this.$refs.audioPlayer;
      if (audio) {
        this.duration = audio.duration;
      }
    },
    onPlay() {
      this.isPlaying = true;
    },
    onPause() {
      this.isPlaying = false;
    },
    onAudioEnded() {
      this.isPlaying = false;
      this.currentTime = 0;
    },
    formatTime(seconds) {
      if (!seconds || isNaN(seconds)) return "00:00";
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    },
    initParams() {
      const query = this.$route.query;
      this.extra = query.extra || "";
      this.name = query.name || "";
      this.audioUrl = query.videoUrl || "";
      this.id = query.id || "";
      this.userId = query.userId || "";
      this.createTime = query.createTime || "";

      console.log("details.vue - 接收到的参数:", {
        extra: this.extra,
        name: this.name,
        audioUrl: this.audioUrl,
        id: this.id,
      });
    },
    downloadAudio() {
      if (!this.audioUrl) {
        this.$message.warning("暂无音频资源");
        return;
      }
      const link = document.createElement("a");
      link.href = this.audioUrl;
      link.download = this.name || "audio";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  mounted() {
    this.initParams();
  },
  beforeDestroy() {
    this.pauseAudio();
  },
};
</script>

<style scoped lang="scss">
.details-container {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(#bcdeff 0%, #ffffff 100%);
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  position: relative;
}

.details-container::before {
  content: "";
  position: absolute;
  top: 105px;
  left: 50%;
  transform: translateX(-50%);
  width: 185px;
  height: 150px;
  background-image: url("../../assets/video/wt.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
}

/* 导航栏 */
.nav-bar {
  height: 44px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  flex-shrink: 0;
}

.back-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
  color: #000;
  flex: 1;
  text-align: center;
}

.nav-actions {
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-size: 18px;
}

.details-content {
  width: 100%;
  //   height: 100%;
  // padding: 40px 20px;
  display: flex;
  // flex-direction: column;
  justify-content: center;
  // align-items: center;
  // background: #fff;
  margin-top: 300px;
  .detail-item {
    width: 90%;
    // height: 183px;
    font-size: 16px;
    font-weight: 600;
    color: #000;
    // margin-bottom: 20px;
    border-radius: 30px;
    background: #fff;
    padding: 20px;
    // height: 100%;
    .detail-item-title {
      font-size: 24px;
      font-weight: 600;
      color: #000;
      border-bottom: 1px dashed #000;
      height: 59px;
      line-height: 39px;
      text-align: left;
    }
    .detail-item-content {
      font-size: 16px;
      font-weight: 600;
      // color: #000;
      white-space: normal;
      word-wrap: break-word;
      overflow-wrap: break-word;
      word-break: break-word;
      //   height: 100%;
      padding: 20px;
      text-align: left;
      width: 100%;
      color: rgba(0, 0, 0, 0.85);
      line-height: 48rpx;
      font-family: AlibabaPuHuiTi_2_55_Regular;
    }
  }
}

.bf {
  width: 100%;
  height: 90px;
  // background: red;
  // margin-top: 10px;
  margin: 20px auto;
  display: flex;
  justify-content: center;
  .bfq {
    width: 90%;
    // background: blue;
    height: 100%;
    display: flex;
    align-items: center;
    .bf-btn-play,
    .bf-btn-pause {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 2px solid #bcdeff;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
    .bf-btn-play:hover,
    .bf-btn-pause:hover {
      transform: scale(1.15);
      border-color: #5ca3f6;
      box-shadow: 0 6px 16px rgba(92, 163, 246, 0.4);
    }
    .bf-btn-play i,
    .bf-btn-pause i {
      font-size: 28px;
      color: #5ca3f6;
      margin-left: 3px;
    }
    .bf-btn-pause i {
      margin-left: 0;
    }
    .bf-btn-play:active,
    .bf-btn-pause:active {
      transform: scale(0.95);
    }
  }
}
.bf-btn {
  display: flex;
  //   justify-content: space-between;
  justify-content: center;
  align-items: center;
  width: 90%;
  padding-left: 20px;
  position: fixed;
  bottom: 20px;
  .bf-btn-text {
    width: 60px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid rgba(0, 0, 0, 0.85);
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
  .bf-btn-download {
    width: 226px;
    height: 40px;
    background: linear-gradient(
      90deg,
      #5ca3f6 0%,
      rgba(92, 179, 246, 0.8) 100%
    );
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
}
.bf-progress {
  width: 80%;
  margin: 0 10px;
  text-align: left;
  .bf-time {
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 10px;
  }
  .bf-duration {
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
}
</style>
